// Grants and revokes change only the session status, which every mutation
// invalidates. Both wait for it to be read again: the tile's button leaves its
// in-flight state when the call settles, and a settle ahead of the new status
// put the button back on Grant Access for a beat before it showed the grant.
import { useMutation, useQuery } from "@tanstack/vue-query";

import { grantAcl, revokeAcl, type GrantAclInput } from "../api/portal";
import { getSystemStatus } from "../api/system";
import { systemKeys } from "./system";

// A failed read counts as "local login not off", so the form does not wait on
// a retry.
export function usePublicSystemStatus() {
  return useQuery({
    queryKey: systemKeys.status(),
    queryFn: ({ signal }) => getSystemStatus({ signal }),
    retry: false,
  });
}

// Bypasses the cache, since an answer from before the network dropped would be
// wrong.
export const probeSystemStatus = (options: { signal?: AbortSignal } = {}) => getSystemStatus(options);

export function useGrantAcl() {
  return useMutation({
    mutationFn: (input: GrantAclInput) => grantAcl(input),
    meta: { invalidates: [], status: "await" },
  });
}

export function useRevokeAcl() {
  return useMutation({
    mutationFn: (aclId: string) => revokeAcl(aclId),
    meta: { invalidates: [], status: "await" },
  });
}
